<template>
	<div>
		<el-row class="pg-header" :gutter="10">
			<el-col :span="17">
				<label class="title">
					今日工作
				</label>
			</el-col>
			<el-col :span="7" style="justify-content: space-between; align-items: center; display: flex;">
				<label style="padding-left:5px;" v-text="today2"></label>
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>工作台</span>
				</div>
			</el-col>
		</el-row>		
		
		<el-row :gutter="10">
			<el-col :span="17">
				<el-row :gutter="10">
					<el-col :span="6">
						<el-card class="work-data">
							<div slot="header" class="el-card-header">
								<span>院中（{{dataCount.inHospitalTotal}}）</span>
							</div>
							<div class="el-card-main">
								<div class="item">待管理 <router-link class="fc key noline" :to="{name:'Hospital/Common',query:{status:1}}" v-text="dataCount.waitingAllocated"></router-link></div>
								<div class="item">管理中 <router-link class="fc key noline" :to="{name:'Hospital/Common',query:{status:2}}" v-text="dataCount.finishAllocated"></router-link></div>
								<div class="item">已完成 <router-link class="fc key noline" :to="{name:'Hospital/Common',query:{status:3}}" v-text="dataCount.donotAllocated"></router-link></div>
							</div>
						</el-card>
					</el-col>

					<el-col :span="6">					
						<el-card class="work-data">
							<div slot="header" class="el-card-header">
								<span>门诊排期（{{dataCount.schdulingTotalOP}}）</span>
<!-- 								<div class="more">
									<router-link :to="{name: 'Login'}"><i class="el-icon-arrow-right link"></i></router-link>
								</div> -->
							</div>
							<div class="el-card-main">
								<div class="item">待排期 <router-link class="fc key noline" :to="{name:'Schedule/Common', query: {datasources:1,status:1}}" v-text="dataCount.waitingSchdulingNumberOP"></router-link></div>
								<div class="item">已排期 <router-link class="fc key noline" :to="{name:'Schedule/Common', query: {date: today,datasources:1,status:2}}" v-text="dataCount.finishSchdulingNumberOP"></router-link></div>
								<div class="item">勿访 <router-link class="fc key noline" :to="{name:'Schedule/Common', query: {date: today,datasources:1,status:3}}" v-text="dataCount.donotVisitNumberOP"></router-link></div>
							</div>
						</el-card>
					</el-col>
					<el-col :span="6">
							<el-card class="work-data">
								<div slot="header" class="el-card-header">
									<span>出院排期（{{dataCount.schdulingTotal}}）</span>
	<!-- 								<div class="more">
										<router-link :to="{name: 'Login'}"><i class="el-icon-arrow-right link"></i></router-link>
									</div> -->
								</div>
								<div class="el-card-main">
									<div class="item">待排期 <router-link class="fc key noline" :to="{name:'Schedule/Common', query: {datasources:2,status:1}}" v-text="dataCount.waitingSchdulingNumber"></router-link></div>
									<div class="item">已排期 <router-link class="fc key noline" :to="{name:'Schedule/Common', query: {date: today,datasources:2,status:2}}" v-text="dataCount.finishSchdulingNumber"></router-link></div>
									<div class="item">勿访 <router-link class="fc key noline" :to="{name:'Schedule/Common', query: {date: today,datasources:2,status:3}}" v-text="dataCount.donotVisitNumber"></router-link></div>
								</div>
							</el-card>
						</el-col>
					<el-col :span="6">
						<el-card class="work-data">
							<div slot="header" class="el-card-header">
								<span>随访（{{dataCount.followupTotal}}）</span>
							</div>
							<div class="el-card-main">
								<div class="item">待随访 <router-link class="fc key noline" :to="{name:'Follow/Common', query: {status:1}}" v-text="dataCount.waitingFollowupNumber"></router-link></div>
								<div class="item">已随访 <router-link class="fc key noline" :to="{name:'Follow/Common', query: {date: today,status:2}}" v-text="dataCount.finishFollowupNumber"></router-link></div>
								<div class="item">终止随访 <router-link class="fc key noline" :to="{name:'Follow/Common', query: {date: today, state: 4,status:4}}" v-text="dataCount.stopFollowupNumber"></router-link></div>
							</div>
						</el-card>
					</el-col>
					<!-- <el-col :span="8">
						<el-card class="work-data">
							<div slot="header" class="el-card-header">
								<span>复诊（{{dataCount.followupVisitTotal}}）</span>
							</div>
							<div class="el-card-main">
								<div class="item">待复诊 <router-link class="fc key noline" :to="{name:'Follow/Subsequent', query: {date: today}}" v-text="dataCount.waitingFollowupVisitNumber"></router-link></div>
								<div class="item">已复诊 <router-link class="fc key noline" :to="{name:'Follow/Subsequent', query: {date: today, state: 1}}" v-text="dataCount.finishFollowupVisitNumber"></router-link></div>
								<div class="item"></div>
							</div>
						</el-card>
					</el-col> -->
				</el-row>
				<el-card class="calendar">
					<div class="el-card-main">
						<el-row>
							<el-col :span="15">
								<v-calendar color="blue" is-expanded :attributes="calendar.attr" @dayclick="handleCalendar" @update:to-page="handleCalendarMonth"></v-calendar>
							</el-col>
							<el-col :span="9">
								<div class="follow-up">
									<div class="no-data" style="padding-top: 110px" v-if="calendar.data.length == 0">暂无预约记录</div>
									<div class="check-date" v-else>
										<div class="item date" v-text="calendar.day"></div>
										<div class="item" v-for="item in calendar.data" :key="item.id">
											<router-link class="fc key noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: item.patientId, t: 3,t2:3, fid: item.recordId,datasources:item.datasources}}">
												{{item.name}}
												<span v-if="item.returnVisitState == 0">待复诊</span>
												<span class="fc green" v-if="item.returnVisitState == 1">已复诊</span>
												<span class="fc orange" v-if="item.returnVisitState == 2">未履约</span>
											</router-link>
										</div>
<!-- 										<div class="item"><span>王大锤</span><span class="fc orange">未履约</span></div>
										<div class="item"><span>王大锤</span><span>待复诊</span></div> -->
									</div>
								</div>

							</el-col>
						</el-row>
					</div>
				</el-card>
								
			</el-col>
			<el-col :span="7">
				<el-card>
					<UserMessage :autoRefresh="false" />
				</el-card>	
				<el-card>
					<div slot="header" class="el-card-header">
						<span>小工具</span>
					</div>
					<div class="el-card-main">
						<el-row class="tool-wrap">
							<!-- <router-link class="noline" target="_blank" :to="{name: 'Patient/NoIdentity'}"> -->
							<!-- <el-col :span="8"><span class="tool t1"><i class="icon-search-fail"></i><span>抓取失败查询</span></span></el-col>
							<el-col :span="8"><span class="tool t2"><i class="icon-search-fail"></i><span>抓取失败查询</span></span></el-col>
							<el-col :span="8"><span class="tool t3"><i class="icon-record"></i><span>沟通记录查询</span></span></el-col>					 -->		
							<el-col :span="8"><router-link class="tool t1 noline" :to="{name: 'Patient/NoIdentity'}"><i class="icon-idcard"></i><span>无身份证患者</span></router-link></el-col>
							<el-col :span="8"><router-link class="tool t2 noline" :to="{name: 'System/ErrorMsg'}"><i class="icon-search-fail"></i><span>错误日志</span></router-link></el-col>
							<el-col :span="8"><span class="tool t3"><i class="icon-record"></i><span>沟通记录查询</span></span></el-col>
						</el-row>
					</div>
				</el-card>
				
			</el-col>
		</el-row>

		<el-row :gutter="10">
			<el-col :span="8">
				<el-card>
					<div slot="header" class="el-card-header">
						<span v-text="chart1.series[0].name" title="门诊人次"></span>
					</div>
					<div class="el-card-main">
						<chart :options="chart1"></chart>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8">
				<el-card>
					<div slot="header" class="el-card-header">
						<span v-text="chart2.series[0].name" title="住院人次"></span>
					</div>
					<div class="el-card-main">
						<chart :options="chart2"></chart>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8">
				<el-card>
					<div slot="header" class="el-card-header">
						<span v-text="chart3.series[0].name" title="出院人次"></span>
					</div>
					<div class="el-card-main">
						<chart :options="chart3"></chart>
					</div>
				</el-card>
			</el-col>
		</el-row>
				
	</div>


</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import VCalendar from 'v-calendar/lib/components/calendar.umd';
import {Chart} from 'highcharts-vue';
import UserMessage from '@/components/UserMessage';

export default {
  components: {Chart, VCalendar, UserMessage},
	mixins: [mixin],
	data(){
		return {
			today: dayjs().format('YYYY-MM-DD'),
			today2: dayjs().format('YYYY年MM月DD日'),
			calendar: {
				day: dayjs().format('YYYY年 MM月DD日'),
				data: [],
				attr: [{
					key: 'active',
					highlight: true,
					dates: new Date()
				}, {
					key: 'data',
					dot: 'red',
					// popover: {label: '描述内容'},
					dates: []
				}]
			},
			chart1: {
				chart: {type: 'line', height: 300},
				title: {text: '233人次', align: 'left', margin: 30, style: {'font-size': '14px'}},
				subtitle: {text: '截至昨天 23:59:59', align: 'left', style: {'color': '#bbb'}},
				legend: {enabled: false},
				xAxis: {categories: ['周一','周二','周三','周四','周五','周六','周日']},
				yAxis: {title: {text: ''}},
				plotOptions: {line: {dataLabels: {enabled: true}, enableMouseTracking: true}},
				credits: {enabled: false},
				colors: ['#2dd3af'],
				series: [{name: ''}]
			},
			chart2: {
				chart: {type: 'line', height: 300},
				title: {text: '233人次', align: 'left', margin: 30, style: {'font-size': '14px'}},
				subtitle: {text: '截至昨天 23:59:59', align: 'left', style: {'color': '#bbb'}},
				legend: {enabled: false},
				xAxis: {categories: ['周一','周二','周三','周四','周五','周六','周日']},
				yAxis: {title: {text: ''}},
				plotOptions: {line: {dataLabels: {enabled: true}, enableMouseTracking: true}},
				credits: {enabled: false},
				colors: ['#2dd3af'],
				series: [{name: ''}]
			},
			chart3: {
				chart: {type: 'line', height: 300},
				title: {text: '233人次', align: 'left', margin: 30, style: {'font-size': '14px'}},
				subtitle: {text: '截至昨天 23:59:59', align: 'left', style: {'color': '#bbb'}},
				legend: {enabled: false},
				xAxis: {categories: ['周一','周二','周三','周四','周五','周六','周日']},
				yAxis: {title: {text: ''}},
				plotOptions: {line: {dataLabels: {enabled: true}, enableMouseTracking: true}},
				credits: {enabled: false},
				colors: ['#2dd3af'],
				series: [{name: ''}]
			},
			dataCount: {},
			listMessage: {
				data: undefined,
			}
		}
	},
	async created() {
		let res;
		let series = [];
		let categories = [];
		this.isLoading = true;
		res = await api.getWorkbenchScheduling({queryDate: this.today});
		if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
		this.dataCount = res.data;

		// 个人消息
		this.loadMessage();

		// 日历
		await this.loadCalendar();

		// 图表
		res = await api.getWorkbenchWeek({queryDate: this.today});
		if (res.data) {
			this.chart1.title.text = res.data['0'].title;
			this.chart1.subtitle.text = res.data['0'].subtitle;
			res.data['0'].workbenchWeekDetailVOS.forEach(item=>{
				categories.push(item.date);
				series.push(item.total)
			})
			this.chart1.xAxis.categories = categories;
			this.chart1.series = [{name: res.data['0'].name, data: series}];
			
			series = [];
			this.chart2.title.text = res.data['1'].title;
			this.chart2.subtitle.text = res.data['1'].subtitle;
			res.data['1'].workbenchWeekDetailVOS.forEach(item=>{
				series.push(item.total)
			})
			this.chart2.xAxis.categories = categories;
			this.chart2.series = [{name: res.data['1'].name, data: series}];
			
			series = [];
			this.chart3.title.text = res.data['2'].title;
			this.chart3.subtitle.text = res.data['2'].subtitle;
			res.data['2'].workbenchWeekDetailVOS.forEach(item=>{
				series.push(item.total)
			})
			this.chart3.xAxis.categories = categories;
			this.chart3.series = [{name: res.data['2'].name, data: series}];
		}
		this.isLoading = false;
	},	
	methods: {
		async loadCalendar(day) {
			let res = await api.getWorkbenchCalendar({queryDate: day || this.today});
			if (res.data) {
				// 这样处理才能刷新UI数据
				let attr = this.calendar.attr.slice();
				// attr[0].dates = [new Date('2020/11/02'), new Date('2020/11/03'), new Date('2020/11/28')];
				attr[1].dates = res.data.returnVisit.map(item=>{return new Date(item);});
				this.calendar.attr = attr;
				
				this.calendar.data = res.data.followupAppointmentReturnVisitDetailByWorkbenchVOS;
			}
		},
		async loadMessage() {
			let res = await api.getWorkbenchMessage();
			if (res.data) {
				this.listMessage.data = res.data;
			}
		},
		handleCalendar(item) {
			console.log('有数据', !!item.popovers, item.id);
			if (item.popovers) {
				let attr = this.calendar.attr.slice();
				// 设置当前选中的日期
				attr[0].dates = new Date(item.id);
				this.calendar.attr = attr;
				this.calendar.day = dayjs(item.id).format('YYYY年 MM月DD日');
				
				this.loadCalendar(item.id);
			}
		},
		handleCalendarMonth(obj) {
			this.loadCalendar(`${obj.year}-${obj.month}-01`);
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

.tool-wrap {
	.tool {
		width: 70px;
		height: 70px;
		border-radius: 10px;
		text-align: center;
		display: block;
		&:hover {
			color: @fckey;
			box-shadow: 0 0 8px 2px rgba(0,0,0,.1);
		}
		span {font-size: 12px; white-space: nowrap; display: block; transform: scale(.86)}
		i {
			padding: 12px 0 5px;
			font-size: 20px;
			display: block;
		}
	}
}
.work-data {
	.item {
		height: 60px;
		line-height: 60px;
		justify-content: space-between;
		display: flex;
		&:nth-child(n+2) {
			border-top: 1px solid #f6f6f6;
		}
		span { color: @fckey;}
	}
}
.calendar {
	margin-top: 20px;
	.vc-container {
		border: none;
	}
	.follow-up {
		height: 275px;
		margin-left: 20px;
		padding-left: 40px;
		border-left: 1px solid @fcgray;
		overflow: auto;
		.check-date {
			position: relative;
			padding-left: 20px;
			&::before {
				position: absolute;
				top: 20px;
				left: 0;
				width: 2px;
				height: 100%;
				min-height: 250px;
				background: #0FD7DB;
				content: '';
			}
			&:nth-child(2) {
				&::before {background: #0F87DB;}
				.item.date::before {background: #0F87DB;}
			}
			&:nth-child(3) {
				&::before {background: #950FDB;}
				.item.date::before {background: #950FDB;}
			}
		}
		.item {
			position: relative;
			height: 36px;
			line-height: 36px;
			color: #bbb;
			&.date {
				color: @fc;
				&::before {
					position: absolute;
					top: 16px;
					left: -23px;
					width: 8px;
					height: 8px;
					border-radius: 100%;
					background: #0FD7DB;
					content: '';					
				}
			}
			span {
				display: inline-block;
				&:nth-child(1) {
					width: 80px;
				}
			}
		}
	}
}

:deep(.user-message) {
	.list-wrap {
		height: 288px;
	}
}
</style>

<style lang="less">
.work-data {
	.el-card__body {
		padding: 0 18px;
	}
}
.calendar {
	.el-card__body {
		padding: 15px 0;
	}
}
</style>